export default function Saw() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="15"
      viewBox="0 0 980.005 711.671"
    >
      <g
        id="_200dcc9090c0a9981b86ad4e70f6f74c"
        data-name="200dcc9090c0a9981b86ad4e70f6f74c"
        transform="translate(-10 -144.169)"
      >
        <g id="Gruppe_1" data-name="Gruppe 1" transform="translate(0 511)">
          <path
            id="Pfad_1"
            data-name="Pfad 1"
            d="M36.01-365c-10.4,3-17.21,8.6-21.81,18.21l-4.2,8.6V-10.68c0,273.69.4,328.71,2.8,334.11,3.2,7.8,12.2,16.41,19.81,19.21,4,1.6,146.05,2.2,467.76,2.2,383.53,0,463.15-.4,468.55-2.8,8.6-3.4,19.01-15.6,20.41-23.61.6-3.6.8-153.85.6-333.91l-.6-327.11-5.4-8.2a38.494,38.494,0,0,0-13-11.8c-7.4-3.8-19.61-3.8-467.75-4.2C201.86-367,40.61-366.4,36.01-365ZM398.53-75.9l.6,211.67L500.96-75.9,602.8-287.37h63.42l.2,212.47V137.77l8-16.01c4.4-8.8,48.82-104.23,98.63-212.07l90.63-196.06,31.21-.6c17.41-.2,31.41.2,31.41,1,0,1-58.42,125.44-129.84,276.69L666.62,265.81H603.2l-1-211.67-1-211.47L499.16,54.74,397.13,266.81H334.11l-.4-213.07-.6-213.27L234.67,53.14,136.24,265.81l-31.41.6c-29.21.4-31.21.2-30.21-3,.8-3.4,249.68-531.78,256.49-544.78l3.2-6h63.82Z"
          />
        </g>
      </g>
    </svg>
  );
}
